module.exports = __webpack_public_path__ + "static/media/card-logo-unknown.2ccbd8a7.svg";